import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useGroupCheckboxValidate } from 'src/components/CookbookCheckboxWrapper/hooks/useGroupCheckboxValidate';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import {
  validateSftpOptionSelection,
  sftpOptions,
} from 'src/components/enterprise/features/Corporate/components/Form/SFTP/utils/SFTP.utils';

export function OptionsCheckboxes(): JSX.Element {
  const { control } = useFormContext();

  const { error, validate } = useGroupCheckboxValidate({
    optionKeys: sftpOptions.map((option) => option.id),
    name: 'sftpOptions',
    validateGroup: validateSftpOptionSelection,
  });

  return (
    <div>
      <Stack y="x-sm">
        <Heading variant="h6" color="primaryText">
          Select the options the client would like to manage through SFTP *
        </Heading>
      </Stack>
      {error && (
        <Stack y="x-sm">
          <Copy variant="body" color="warning">
            {error.message}
          </Copy>
        </Stack>
      )}
      <Stack y="x-sm">
        <Flex flexDirection="column">
          {sftpOptions.map((option) => (
            <CookbookCheckboxWrapper
              control={control}
              id={option.id}
              key={option.id}
              name={`sftpOptions.${option.id}`}
              label={option.label}
              rules={{ validate }}
            />
          ))}
        </Flex>
      </Stack>
    </div>
  );
}
